export function partition<T>(array: T[], fn: (val: T, i: number, arr: T[]) => boolean) {
  return array.reduce(
    (acc: T[][], val, i, arr) => {
      acc[fn(val, i, arr) ? 0 : 1].push(val)
      return acc
    },
    [[], []]
  )
}
